(function () {
  class OutcomesPanel extends PIXI.Container {
    constructor() {
      super();

      this._entryRunningIndex = 0;
      this._createdEntries = [];

      this._entryCoords = [
        { x: 98, y: 150 },
        { x: 98, y: 122 },
        { x: 98, y: 94 },
        { x: 98, y: 66 },
        { x: 98, y: 38 },
      ];

      this._newlyAdded = 0;
      this._positionIndex = 0;
      this._entryOffsetX = -0;
      this._entryOffsetY = 28;
      this._maxEntriesSeenAtOnce = 5;
      this._entryMovePixelsPerMS = 1;
      this._winEntries = [];
      this._emptyArray = []; // leave empty!!!

      this._tempDisableScrolling = false;
    }

    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });

      Reflex.registerEventHandler('orientationChange', () => {
        this.onOrientationChange();
      });
    }

    canScroll() {
      return !this._tempDisableScrolling && this._winEntries.length > this._maxEntriesSeenAtOnce;
    }

    canScrollUp() {
      return this.canScroll() && this._positionIndex > 0;
    }

    canScrollDown() {
      const extraEntries = this._winEntries.length - this._entryCoords.length;
      return this.canScroll() && this._positionIndex < extraEntries;
    }

    async removeEntries() {
      if (this._winEntries.length > 0) {
        // we have entries to drop off the bottom
        await game.tweenFromToAsync(
          this._entryContainer,
          {
            y: this._entryContainer.y,
          },
          {
            y: this._entryContainer.y + 140,
            ease: 'power1.in',
            duration: 0.18,
          }
        );

        for (let i = 0; i < this._winEntries.length; i++) {
          this._winEntries[i].parent.removeChild(this._winEntries[i]);
        }
        this._winEntries = [];
        this._entryContainer.y = 0;
        this._entrySliderContainer.y = 0;
        this._entryRunningIndex = 0;
        this._positionIndex = 0;
      }
    }

    async scrollDown() {
      this._tempDisableScrolling = true;

      soundManager.play('buttonPressed');

      await game.tweenFromToAsync(
        this._entrySliderContainer,
        {
          y: this._entrySliderContainer.y,
        },
        {
          y: this._entrySliderContainer.y - this._entryOffsetY,
          duration: 0.06,
          ease: 'none',
        }
      );
      this._positionIndex++;

      this._tempDisableScrolling = false;
    }

    async scrollUp() {
      this._tempDisableScrolling = true;

      soundManager.play('buttonPressed');

      await game.tweenFromToAsync(
        this._entrySliderContainer,
        {
          y: this._entrySliderContainer.y,
        },
        {
          y: this._entrySliderContainer.y + this._entryOffsetY,
          duration: 0.06,
          ease: 'none',
        }
      );
      this._positionIndex--;

      this._tempDisableScrolling = false;
    }

    createEntry(data, isCapped = false) {
      const symbolIndex = data.symbolIndex;
      const totalWin = data.totalWin;
      const count = data.count;

      let entry = this._createdEntries[this._entryRunningIndex];

      if (!entry) {
        entry = {
          loz: null,
          symbol: null,
          countText: null,
          totalWinningsText: null,
        };

        entry.loz = resourceManager.createObject(
          'sprite', // type
          'entry_' + this._entryRunningIndex,
          'outcomesPanel:OutcomesPanel:masterEntryContainer:entryContainer:entrySliderContainer',
          {
            fileName: 'Outcomes_Panel/Outcome_Button.png',
            anchor: 0.5,
            x: 0,
            y: 0,
          }
        );
        entry.symbol = resourceManager.createObject(
          'movie', // type
          'entry_symbol_' + this._entryRunningIndex,
          entry.loz,
          {
            definition: 'smallSymbolsForOutcomePanel_md',
            anchor: 0.5,
            x: -29,
            y: 0,
          }
        );
        entry.countText = resourceManager.createObject(
          'text', // type
          'entry_count_' + this._entryRunningIndex,
          entry.loz,
          {
            fontDefinition: 'Font_White',
            fontOverrides: {
              fontSize: 20,
              align: 'right',
            },
            x: -44,
            y: 0,
          }
        );
        entry.countText.anchor.set(1, 0.5);
        entry.totalWinningsText = resourceManager.createObject(
          'text', // type
          'entry_totalWinnings_' + this._entryRunningIndex,
          entry.loz,
          {
            fontDefinition: 'Font_White',
            maxWidth: 82,
            fontOverrides: {
              fontSize: 20,
              align: 'right',
            },
            x: 70,
            y: 0,
          }
        );
        entry.totalWinningsText.anchor.set(1, 0.5);
        this._createdEntries[this._entryRunningIndex] = entry;
      }

      entry.symbol.gotoAndStop(symbolIndex);
      entry.countText.setText(`${count}`);
      isCapped = false; // we arent worried about the value being shown here
      if (isCapped === true) {
        // yuck, need to pass empty array
        const text = gdk.translateText('t_maxWin', this._emptyArray);
        entry.totalWinningsText.setText(text);
      } else {
        entry.totalWinningsText.setText(`${gdk.formatCurrency(totalWin)}`);
      }
      this._entryRunningIndex++;

      return entry.loz;
    }

    async addAllWinsToPanel(wins, isCapped = false) {
      const promises = [];
      this._newlyAdded = 0;
      for (let i = 0; i < wins.length; i++) {
        let fullBefore = false;
        if (this._winEntries.length >= this._maxEntriesSeenAtOnce) {
          fullBefore = true;
        }

        promises[i] = this.addWinToPanel(
          {
            symbolIndex: wins[i].symbol,
            totalWin: wins[i].totalWin,
            count: wins[i].winSymPositions.length, // count wont include the wilds
            last: i === wins.length - 1,
          },
          isCapped
        );
        this._newlyAdded++;

        let fullAfter = false;
        if (this._winEntries.length >= this._maxEntriesSeenAtOnce) {
          fullAfter = true;
        }

        // once full we need to wait?
        if (fullBefore || fullAfter) {
          await Promise.all(promises);
        }
      }

      this._newlyAdded = 0;

      await Promise.all(promises);
    }

    async addWinToPanel(win, isCapped = false) {
      const newEntry = this.createEntry(win, isCapped);
      this._entrySliderContainer.addChild(newEntry);
      this._winEntries.push(newEntry);

      if (this._winEntries.length > this._maxEntriesSeenAtOnce) {
        await this.dropEntryOntoPanelWhenFull(newEntry, win.last);
      } else {
        await this.dropEntryOntoPanel(newEntry, win.last);
      }
    }

    async dropEntryOntoPanel(entry) {
      const numOfEntriesInPanel = this._winEntries.length - 1;

      const startY = this._entryCoords[this._entryCoords.length - 1].y - this._entryOffsetY * this._newlyAdded;
      const endY = this._entryCoords[numOfEntriesInPanel].y;
      const distanceY = Math.abs(startY - endY);
      const durationInMS = distanceY * this._entryMovePixelsPerMS;

      await game.tweenFromToAsync(
        entry,
        {
          x: this._entryCoords[numOfEntriesInPanel].x,
          y: startY,
        },
        {
          x: this._entryCoords[numOfEntriesInPanel].x,
          y: endY,
          duration: durationInMS / 1000,
        }
      );
    }

    async dropEntryOntoPanelWhenFull(entry) {
      // we dont have to drop anything i dont think
      // add the entry at the top
      // and move the slider down
      const extraEntries = this._winEntries.length - this._entryCoords.length;
      const offsetY = this._entryOffsetY * extraEntries;
      entry.x = this._entryCoords[0].x;
      entry.y = this._entryCoords[this._entryCoords.length - 1].y - offsetY;

      // now we need to move the slider instead
      // issue here is, this._entrySliderContainer.y may already be moving at this point
      // as we are adding multiples once its already full
      const startY = this._entrySliderContainer.y;
      const endY = this._entrySliderContainer.y + this._entryOffsetY;
      const distanceY = Math.abs(startY - endY);
      const durationInMS = distanceY * this._entryMovePixelsPerMS;
      await game.tweenFromToAsync(
        this._entrySliderContainer,
        {
          y: startY,
        },
        {
          y: endY,
          duration: durationInMS / 1000,
        }
      );
    }

    applyMasks() {
      // this mask is on the main masterEntryContainer, havign a mask here helps with being able to move
      // entryContainer down without worrying about seeing a ton of other entries - should only see a max of 5 slide
      // off when spin is pressed
      const mask1 = new PIXI.Graphics();
      mask1.beginFill(0xff0000);
      mask1.drawRect(23, 23, 150, 142);

      const masterEntryContainer = resourceManager.get('outcomesPanel:OutcomesPanel:masterEntryContainer');
      masterEntryContainer.addChild(mask1);
      masterEntryContainer.mask = mask1;

      // this mask is used so entrySliderContainer can be moved up and down
      const mask2 = new PIXI.Graphics();
      mask2.beginFill(0xff0000);
      mask2.drawRect(23, 23, 150, 142);

      const entryContainer = resourceManager.get('outcomesPanel:OutcomesPanel:masterEntryContainer:entryContainer');
      entryContainer.addChild(mask2);
      entryContainer.mask = mask2;

      // if we only had the one mask, and lets say 20 entries, as you slide off on a spin, you would see all
      // of the entries drop through
      // this way we only need to drop entryContainer down 5 entries worth of y
    }

    onLayoutComplete() {
      this.applyMasks();

      this._entrySliderContainer = resourceManager.get(
        'outcomesPanel:OutcomesPanel:masterEntryContainer:entryContainer:entrySliderContainer'
      );
      this._entryContainer = resourceManager.get('outcomesPanel:OutcomesPanel:masterEntryContainer:entryContainer');

      this._layoutComplete = true;
    }

    onOrientationChange() {
      if (!this._layoutComplete) return;
    }

    createTweens() {}

    hide() {
      this.visible = false;
    }

    show() {
      this.visible = true;
    }

    update() {
      // if (this.stateMachine) {
      //   this.stateMachine.update();
      // }
    }
  }

  create = function (json) {
    return new OutcomesPanel();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return ['Outcomes_Panel/Outcome_Button.png', ''];
  };

  resourceManager.registerObjectType('OutcomesPanel', create, initialise, getFilesRequired);
})();
